<template>
  <Modal v-model="modal" :title="$t('name.cex.query.title')" width="1000" footer-hide scrollable>
    <Row :gutter="20">
      <Col :span="8">
        <i-form>
          <FormItem>
            <Input v-model="form.code" :placeholder="$t('name.cex.query.message')" type="textarea" :autosize="{minRows: 5,maxRows: 10}" />
          </FormItem>
          <FormItem>
            <Button type="primary" @click="onQuery" :loading="loading" long>{{ $t('name.cex.query.button') }}</Button> 
          </FormItem>
        </i-form>
      </Col>
      <Col :span="16">
        <Table ref="table" :list="list" />
      </Col>
    </Row>
  </Modal>
</template>
<script>
import { query } from '@/api/cex'
import Table from './table'

export default {
  components: {
    Table
  },
  data() {
    return {
      loading: false,
      modal: false,
      list: [],
      form: {
        code: ''
      }
    }
  },
  methods: {
    open(code = '') {
      this.modal = true
      this.form.code = code
    },
    onQuery() {
      this.loading = true
      // 分割
      const code = this.form.code.split('\n')
      query({ code }).then(res => {
        this.loading = false
        this.list = res
      })
    }
  },
};
</script>